import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root {
    --app-font-size: 13px;
    --navbar-height: 50px;
    --footer-height: 25px;
    --general-padding: 15px;
    --pagination-height: 40px; 
    --toolbar-height: 40px; 

    --font-display: 'Outfit', sans-serif;
    --font-body: 'Plus Jakarta Sans', sans-serif;
    --font-mono: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: var(--font-body);
    background-color: ${(props) => props.theme.background};
    color: ${(props) => props.theme.text};
    font-size: var(--app-font-size);
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  *, *::before, *::after {
    font-family: inherit;
  }

  .div-container {
    display: flex;
    overflow: hidden;
    height: calc(100vh - (var(--navbar-height) + var(--footer-height)));
    padding: var(--general-padding);
    transition: padding 0.3s ease;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  
  .hover{
    cursor: pointer;
    vertical-align: middle;
    transition: transform 0.15s ease, opacity 0.15s ease;
  
    &:hover {
      transform: scale(1.40);
      opacity: 0.7;
    }
  }

  @media (max-width: 768px) {
    :root {
      --app-font-size: 12px;
      --pagination-height: 36px;
      --toolbar-height: 36px;
    }
  }

  @media (min-width: 1920px) {
    :root {
      --app-font-size: 14px;
      --pagination-height: 44px;
      --toolbar-height: 44px;
    }
  }
`;